import { Component, OnInit, Injector, AfterViewInit } from '@angular/core';
import { BaseComponent } from '../../base.component';
import { isEmpty } from 'lodash';
@Component({
	selector: 'SubSectionTitle',
	host: { '[class]': 'myCustomClass' },
	template: `
		<h2
			gtm-handler
			events="{{ addEvent() }}"
			handlerType="button"
			label="KickOut phone {{ this.control.attributes.phone }}"
			action="ButtonClick"
			style="{{ control.attributes.style }}"
			[ngClass]="{ 'covmod-sub-section-title': isCovModFlagOn }"
			innerHtml="{{ control.attributes.title }}"
		></h2>
	`,
	styleUrls: ['./sub-section-title.component.scss'],
})
export class SubSectionTitleComponent extends BaseComponent implements OnInit, AfterViewInit {
	gtmHandler: any;
	isCovModFlagOn: boolean = false;

	SubTitlegtmHandler() {
		return !isEmpty(this.control.attributes.phone) ? this.addGtmHandlerToPhome() : {};
	}

	addGtmHandlerToPhome() {
		return {
			events: ['click'],
			type: 'button',
			label: 'KickOut phone ' + this.control.attributes.phone,
			action: 'ButtonClick',
		};
	}

	async ngOnInit() {
		this.layoutService.globalAttributes.subscribe((data) => {
			this.isCovModFlagOn = data['covModFlag'];
		});

		if (this.isCovModFlagOn) {
			const elem = this.elementRef.nativeElement.parentElement.parentElement.parentElement;
			this.Renderer.setStyle(elem, 'margin-bottom', '5px');
		}
	}

	ngAfterViewInit() {
		let anchors = this.elementRef.nativeElement.querySelectorAll('a');
		anchors.forEach((anchor: HTMLAnchorElement) => {
			anchor.addEventListener('click', () => {
				this.customEvent();
			});
		});
	}

	addEvent() {
		return !isEmpty(this.control.attributes.phone) ? 'click' : '';
	}

	customEvent() {}
}
